import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
    Text, View, Image, ScrollView, FlatList,
    TouchableOpacity, Animated, Pressable
} from 'react-native';
import { debounce } from "lodash";
import { store } from '../../store/store';
import { View as AnimatableView } from "react-native-animatable";

import { checkIfShowA2shBtn, onPressA2HS } from '../../utils/services/A2HSUtils';
import { updateUserSelectedLocationToRedux } from '../../utils/services/redux/commonRedux';
import { checkAayuSubscriptionValidity, checkRouteNavigateFrom, checkUserNameLastChar, getImagePath, getMemberProfileURL, getPluralString, isGuestTokenValid, isObjectNotEmpty } from '../../utils/services/CommonUtils';

import { GooglePlayBadge } from '../../utils/widgets/CommonAayuLogo';
import { DashboardShimmer } from '../shimmer-component/ScreenShimmer';
import { DashboardActivityViewDesign } from '../../utils/widgets/ActivityViewDesign';
import { ChemistStoreCardView } from '../../utils/widgets/chemist/ChemistStoreCardView';
import { CommonRightChevronIcon, DashboardFeatureCard, OrganisationStatsView } from '../../utils/widgets/Common-Widget';

import { CopyRight, } from "../../utils/constants/AppConstants";
import { newSubscriptionData } from '../../utils/constants/acs/aayuCardMapping';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import AppStyles from "../../AppStyles";
import TextStyle from '../../TextStyle';

import FaqsComponent from "../../utils/widgets/FaqsComponent";

import * as Rxjs from "../../utils/services/subject-behaviour/CommonRxjsService";

const DashboardComponent = (props) => {

    const reduxState = store.getState()

    const isUserLoggedIn = reduxState.isUserLogin ? true : false

    const animationValue = new Animated.Value(60)
    const userVisistedStoreListRef = useRef<FlatList<any>>(null);

    const [dashboardComponentInitialised, setComponentInitialised] = useState(false)
    const [dashboarData, setDashboardData] = useState({
        userData: {},
        subscription: newSubscriptionData,
    });

    const [render, updateRenderState] = useState(false);

    const [navigateFrom, updateNavigateTo] = useState(global.navigateFrom ?? '');

    const [hasInternalRedirection, updateHasInternalRedirection] = useState(false);

    const [hasCheckedNavigateTo, updateCheckedNavigateTo] = useState(false)

    const [activityList, updateActivityList] = useState([])
    const [activityActiveListLenght, updateActivityActiveListLenght] = useState(0)

    const [userVisitedStore, setUserVisitedStore] = useState([])

    const [rxjsSelectedLocation, updateRxjsSelectedLocation] = useState({})

    const [isShowA2hsCta, setIsShowA2hsCta] = useState(false)

    const checkDashboardScreenIsOnFocus = () => {
        const { navigation }: any = props;
        // navigation.addListener("focus", () => {
        //     if (allowUpdateDashboardData) {
        //         updateBagItemCount(getBagItemCount())
        //     } else {
        //         allowUpdateDashboardData = false;
        //     }
        // });

        // navigation.addListener("blur", () => {
        //     if (!allowUpdateDashboardData) {
        //         allowUpdateDashboardData = true;
        //     }
        // });
    }

    const checkNavigateTo = () => {
        if (!hasCheckedNavigateTo) {
            updateCheckedNavigateTo(true)
            if (navigateFrom)
                updateHasInternalRedirection(true);
            updateNavigateTo('');
            checkRouteNavigateFrom(props, navigateFrom)
        }
    }

    const checkDataDependentNavigateTo = (subscriptionData) => {
        // handle check navigate to if their is dependency on data.
        if (!hasCheckedNavigateTo) {
            updateCheckedNavigateTo(true)
            if (navigateFrom)
                updateHasInternalRedirection(true);
            updateNavigateTo('');
            if (navigateFrom === NavigateFrom.acs_plans) {
                setTimeout(() => {
                    if (subscriptionData.valid)
                        props.navigation.navigate(ScreenRoute.acs_current_plan, {});
                    else {
                        Rxjs.selectedAayuCardForPurcahseSubscription.
                            getSelectedAayuCard().subscribe((selectedAayuCard) => {
                                props.navigation.navigate(ScreenRoute.payment_online, {
                                    serviceParams: selectedAayuCard['serviceParams'],
                                    serviceName: selectedAayuCard['serviceName']
                                });
                            })
                    }
                    updateRenderState(true)
                }, 200)
            }
        }
    }

    const dashboardRxjsSubscriptions = () => {

        Rxjs.userDetailsSubscription.getUserDetails().
            subscribe((userData: any) => {
                if (userData) {
                    dashboarData.userData = userData
                    setDashboardData(dashboarData)
                }
            });

        Rxjs.selectedLocationForDashboard.getSelectedLocation().
            subscribe((location: any) => {
                if (location) updateRxjsSelectedLocation(location)
            });

        Rxjs.activtyDataSubscription.getActiviytData().
            subscribe((updatedActivityData: any) => {
                if (updatedActivityData) {
                    if (updatedActivityData.activityList)
                        updateActivityList(updatedActivityData.activityList)
                    if (updatedActivityData.activityActiveListLenght)
                        updateActivityActiveListLenght(
                            updatedActivityData.activityActiveListLenght)
                }
            })
    }


    useEffect(() => {
        if (!navigateFrom && !hasInternalRedirection)
            global.lastHashCode = '/' + ScreenRoute.tab_controller_screen;

        // check if current screen is in stack or is rendering.
        checkDashboardScreenIsOnFocus()

        if (!dashboardComponentInitialised) {
            setComponentInitialised(true)
            if (reduxState.isUserLogin) {
                dashboardDataSubscriptions()
                store.subscribe(() => {
                    dashboardDataSubscriptions()
                })
                dashboardRxjsSubscriptions()
            }
        }

        if (reduxState.isUserLogin) {
            setTimeout(() => {
                if (navigateFrom != NavigateFrom.acs_plans) {
                    checkNavigateTo();
                    updateRenderState(true)
                }
            }, navigateFrom ? 100 : 0)
        } else {
            checkIfShowA2shBtn(setIsShowA2hsCta)
            updateRenderState(true)
        }
    }, []);


    const dashboardDataSubscriptions = useCallback(
        debounce(() => updateDashboardData(), 200), [])

    const updateDashboardData = () => {
        const _reduxState: any = store.getState();
        let subscriptionData = checkAayuSubscriptionValidity(
            _reduxState.subscriptionData)
        var dashboardData = {
            userData: _reduxState.userDetails,
            subscription: subscriptionData
        }
        var visitedStore = _reduxState.userVisitedStore ?? []
        setDashboardData(dashboardData)
        checkDataDependentNavigateTo(subscriptionData)
        setUserVisitedStore(visitedStore)
    }


    useEffect(() => {
        Animated.timing(animationValue, {
            toValue: 0, duration: 1000,
            delay: 4000, useNativeDriver: true,
        }).start()
        // < Don't forget to start!
    }, [])

    const onPressOrderMedicineCard = () => {
        const reduxState = store.getState()
        if (reduxState.isUserLogin || isGuestTokenValid()) {
            if (isObjectNotEmpty(rxjsSelectedLocation)) {
                updateUserSelectedLocationToRedux(rxjsSelectedLocation)
                props.navigation.navigate(ScreenRoute.list_pharmacy, { selectedLocation: rxjsSelectedLocation })
            }
            else props.navigation.navigate(ScreenRoute.oms_detect_user_location, {})
        }
    }

    const onPressConsultDoctorCard = () => {
        if (isUserLoggedIn) {
            if (dashboarData.userData['isProfileComplete']) {
                const consultList: any = store.getState().consultationList ?? [];
                props.navigation.navigate(
                    consultList.length === 0 ?
                        ScreenRoute.econsult_start :
                        ScreenRoute.member_selection, {})
            } else {
                props.navigation.navigate(ScreenRoute.complete_profile,
                    { screenRedirect: ScreenRoute.member_selection })
            }
        } else {
            global.navigateFrom = NavigateFrom.dashboard_for_econsult
            props.navigation.navigate(ScreenRoute.login, {})
        }
    }

    const onPressOfAayuCard = () => {
        const reduxState = store.getState()
        if (reduxState.isUserLogin || isGuestTokenValid()) {
            props.navigation.navigate(dashboarData.subscription['route'], {})
        }
    }

    return (
        <View style={{ paddingBottom: props?.getBottomPadding() ?? 0 }}>

            {/* <DashboardHeader onPressA2HS={onPressA2HS}
                value={animationValue}
                isA2HSAdded={false}
                isShowA2hsCta={isShowA2hsCta} /> */}

            <Pressable style={[AppStyles.header, AppStyles.px16, AppStyles.py8]}
                onLongPress={() => { console.log('### long press') }}
                onPress={() => { props.navigation.navigate(ScreenRoute.profile_screen) }}>
                <View style={[AppStyles.borderViewRound, AppStyles.bgWhite, { padding: 2 }]}>
                    <Image style={[AppStyles.border12, { width: 24, height: 24 }]}
                        source={{ uri: getMemberProfileURL(dashboarData.userData) }} />
                </View>
                {isShowA2hsCta ? <AnimatableView style={[AppStyles.flexRowCenter, {
                    alignContent: "flex-end", borderWidth: 2,
                    width: animationValue?.interpolate({ inputRange: [0, 100], outputRange: ['0%', '100%'] }) ?? props?.width,
                    maxWidth: animationValue?.interpolate({ inputRange: [0, 100], outputRange: ['0%', '100%'] }) ?? props?.width,
                    borderColor: '#000000', borderRadius: 50, padding: 10, minWidth: 45
                }]}>
                    <TouchableOpacity style={{ paddingLeft: 4 }} onPress={() => { onPressA2HS() }}>
                        <Image style={{ marginRight: 3 }} source={{ uri: getImagePath('/images/icons/save_to_home_screen.svg'), width: 14, height: 19.5 }} />
                    </TouchableOpacity>
                    <Text onPress={() => { onPressA2HS() }}
                        numberOfLines={1} style={[TextStyle.text14b, {}]}>
                        {' Add To Home Screen'}</Text>
                </AnimatableView> : null}
            </Pressable>

            {
                render ? <ScrollView style={{ marginTop: AppTheme.headerHeight + (isShowA2hsCta ? 10 : 0) }}>

                    <View style={{ paddingBottom: 24 }}>

                        {
                            dashboarData.userData['isNameCaptured'] ?
                                <View style={[AppStyles.flexRowSpaceBetween,
                                { padding: 16, alignContent: 'center', alignItems: 'center' }]}>
                                    <Text style={[TextStyle.text16b,
                                    { width: AppTheme.appWidth * 0.8 }]}>
                                        Hello, {checkUserNameLastChar(dashboarData.userData['name']).toUpperCase()} family!</Text>
                                    {
                                        dashboarData.subscription['valid'] ?
                                            <Pressable onPress={() => {
                                                props.navigation.navigate(
                                                    ScreenRoute.acs_current_plan, {})
                                            }} onLongPress={() => { console.log('### long press') }}>
                                                <Image style={{ width: 28, height: 30 }}
                                                    source={{ uri: getImagePath('/images/aayuCard/aayu_subs_sheild.svg') }} />
                                            </Pressable> : null}
                                </View> : <View style={{ height: 16 }} />
                        }

                        <AnimatableView animation="fadeIn" duration={AppTheme.transitionDuration} delay={300} useNativeDriver>
                            <TouchableOpacity onPress={() => { onPressOrderMedicineCard() }}>
                                {DashboardFeatureCard('Order Now', 'dashboard_oms', AppTheme.color.primary)}</TouchableOpacity>
                        </AnimatableView>

                        {userVisitedStore.length > 0 && <AnimatableView animation="fadeIn" duration={AppTheme.transitionDuration} delay={300} useNativeDriver>
                            <Text style={[TextStyle.text16xb, AppStyles.mt16, AppStyles.px16]}>
                                {getPluralString(userVisitedStore.length, 'Visited Store')}</Text>
                            <FlatList data={userVisitedStore}
                                ref={userVisistedStoreListRef}
                                keyExtractor={item => item?.id}
                                renderItem={({ item, index }) =>
                                    <ChemistStoreCardView index={index} key={item['id']}
                                        pharmacy={item} />}
                                renderToHardwareTextureAndroid snapToAlignment="start" />

                        </AnimatableView>}

                        <AnimatableView animation="fadeIn" duration={AppTheme.transitionDuration} delay={500} useNativeDriver>
                            <TouchableOpacity onPress={() => { onPressConsultDoctorCard() }}
                                style={{ marginTop: 16 }}>
                                {DashboardFeatureCard('Consult Now', 'dashboard_consultation', AppTheme.color.green.primary)}</TouchableOpacity>
                        </AnimatableView>

                        {
                            activityActiveListLenght > 0 ?
                                <AnimatableView animation="fadeIn"
                                    duration={AppTheme.transitionDuration}
                                    delay={800}
                                    useNativeDriver>

                                    <View style={[AppStyles.flexRowSpaceBetween,
                                    { marginLeft: 16, marginRight: 16, marginTop: 18 }]}>

                                        <Text style={[TextStyle.text16xb]}>
                                            Recent Activities</Text>

                                        <TouchableOpacity onPress={() => {
                                            props.navigation.navigate(
                                                ScreenRoute.list_user_services, {})
                                        }}>

                                            <View style={AppStyles.flexRow}>

                                                <Text style={[TextStyle.text14b,
                                                {
                                                    color: AppTheme.color.primary,
                                                    marginRight: 6
                                                }]}>See All</Text>
                                                {CommonRightChevronIcon('blue')}

                                            </View>

                                        </TouchableOpacity>

                                    </View>

                                    <ScrollView showsHorizontalScrollIndicator={false} horizontal={true} style={{ paddingBottom: 2 }}>
                                        {
                                            !!activityList && activityList.map((activityData: any, index) => (
                                                <AnimatableView animation='fadeIn'
                                                    style={{}}
                                                    key={activityData['oid'] ?
                                                        activityData['oid'] : activityData['id']}
                                                    duration={AppTheme.transitionDuration}
                                                    useNativeDriver>
                                                    <TouchableOpacity style={{ marginLeft: index == 0 ? 16 : 0 }}>
                                                        <DashboardActivityViewDesign activityList={activityList}
                                                            activityData={activityData}
                                                            navigation={props.navigation} />
                                                    </TouchableOpacity>
                                                </AnimatableView>
                                            ))
                                        }
                                    </ScrollView>

                                </AnimatableView> : null
                        }

                    </View>

                    {dashboarData.subscription['valid'] ? null :
                        <AnimatableView animation="fadeIn"
                            duration={AppTheme.transitionDuration}
                            delay={800} style={{ marginBottom: 24 }}>
                            <TouchableOpacity onPress={() => { onPressOfAayuCard() }}>
                                <Image source={{
                                    uri: getImagePath(dashboarData.subscription['image']), width: AppTheme.appWidth,
                                    height: AppTheme.appWidth * dashboarData.subscription['widthToHeight']
                                }} />
                            </TouchableOpacity>
                        </AnimatableView>}

                    <View style={AppStyles.bgWhite}>

                        <View style={{ paddingBottom: 32, alignItems: 'center' }}>
                            <Text style={TextStyle.text14xb}>Jab Baat Ho Health Ki</Text>
                            <View style={{ height: 24 }} />
                            <View style={[AppStyles.flexRowCenter, { marginHorizontal: 22 }]}>
                                <View>{OrganisationStatsView('40K', 'Chemist Stores')}</View>
                                <View style={{ height: 44, width: 1, marginHorizontal: 8.5, backgroundColor: AppTheme.color.grey.divider }} />
                                <View>{OrganisationStatsView('35L', 'Families Served')}</View>
                                <View style={{ height: 44, width: 1, marginHorizontal: 10.5, backgroundColor: AppTheme.color.grey.divider }} />
                                <View>{OrganisationStatsView('5000', 'Specialist Doctors')}</View>
                            </View>
                        </View>

                        <View style={{ width: AppTheme.appWidth, height: 1.5, backgroundColor: AppTheme.color.grey.divider }} />

                        <View style={{ marginTop: 32, marginBottom: 16, alignItems: 'center' }}>

                            <GooglePlayBadge />

                            <Text style={[TextStyle.text12xb, { marginVertical: 16 }]}>
                                Download Aayu app to avail other benefits.</Text>

                            <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginHorizontal: 8 }}>

                                <Image source={{ uri: getImagePath('/images/aayuFeatures/1.webp') }}
                                    style={{
                                        margin: 8, borderRadius: 12,
                                        width: AppTheme.appWidth / 2 - 24,
                                        height: (AppTheme.appWidth * 0.70) / 2 - 16
                                    }} />

                                <Image source={{ uri: getImagePath('/images/aayuFeatures/2.webp') }}
                                    style={{
                                        margin: 8, borderRadius: 12,
                                        width: AppTheme.appWidth / 2 - 24,
                                        height: (AppTheme.appWidth * 0.70) / 2 - 16
                                    }} />

                                <Image source={{ uri: getImagePath('/images/aayuFeatures/3.webp') }}
                                    style={{
                                        margin: 8, borderRadius: 12,
                                        width: AppTheme.appWidth / 2 - 24,
                                        height: (AppTheme.appWidth * 0.70) / 2 - 16
                                    }} />

                                <Image source={{ uri: getImagePath('/images/aayuFeatures/4.webp') }}
                                    style={{
                                        margin: 8, borderRadius: 12,
                                        width: AppTheme.appWidth / 2 - 24,
                                        height: (AppTheme.appWidth * 0.70) / 2 - 16
                                    }} />

                            </View>

                        </View>

                    </View>


                    <View style={{ backgroundColor: AppTheme.color.background }}>

                        <FaqsComponent faqsPage='dashboardFAQ' navigation={props.navigation} />

                        <View style={[AppStyles.bgWhite, {
                            paddingVertical: 16, marginTop: 12, alignItems: 'center',
                            borderTopLeftRadius: 12, borderTopRightRadius: 12
                        }]}><Text style={TextStyle.text12b}>
                                Copyright {CopyRight} 2022 MedCords</Text></View>
                    </View>

                </ScrollView> : <DashboardShimmer />
            }

            {/* {isObjectNotEmpty(orderSnackBarData) &&
                <BottomSnackBarView navigation={props.navigation}
                    orderList={orderSnackBarData} />} */}

        </View >

    )
}

export default DashboardComponent
